import React from 'react';
import ProfessorPositions from '../components/ProfessorPositions/ProfessorPositions';
import '../components/ProfessorPositions/ProfessorPositionsPage.css';

function ProfessorPositionsPage() {
  return (
    <div className="professor-positions-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-content">
          <h1 className="page-title">Position Management</h1>
          <p className="page-description">
            Create and manage your academic positions, and find the perfect candidates through our intelligent matching system.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="page-content">
        <ProfessorPositions />
      </div>

      {/* Footer */}
      <div className="page-footer">
        <div className="footer-content">
          <p className="footer-text">
            Need help? <a href="/support" className="footer-link">Contact Support</a> or view our <a href="/guide" className="footer-link">Getting Started Guide</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProfessorPositionsPage;
